import classNames from "classnames";
import { AppButton } from "@/shared/Components";
import type { FC, ReactNode } from "react";
import type React from "react";
import type { MenuIconType } from "../types";
import styles from "./styles.module.scss";

interface Props {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  children: ReactNode;
  icon: MenuIconType;
  className?: string;
}

export const MenuCallButton: FC<Props> = ({ onClick, children, icon, className }) => {
  return (
    <AppButton
      type="text"
      className={classNames(styles["menu-call-button"], styles[`menu-icon-${icon}`], className)}
      onClick={onClick}
    >
      {children}
    </AppButton>
  );
};
